module.exports = __webpack_public_path__ + "img/tableau.55347319.svg";